import { Badge } from '@/components';

interface Colors {
  bg: string;
  text: string;
}

type Status = 'success' | 'failure';

export const translation: Record<Status, string> = {
  success: 'Éxito',
  failure: 'Falló',
};

export const httpColor: Record<Status, Colors> = {
  success: { bg: '#C8E6C9', text: '#2E7D32' },
  failure: { bg: '#FFCDD2', text: '#C62828' },
};

const getColorProps = (colors: any, value: string) => ({
  textColor: colors[value].text,
  backgroundColor: colors[value].bg,
  ballColor: colors[value].text,
});

export const renderLastRunStatus = (value: string) => {
  if (!value) return <></>;
  const { textColor, ballColor } = getColorProps(httpColor, value);
  return (
    <Badge
      ballColor={ballColor}
      textColor={textColor}
      value={translation[value as Status]}
    />
  );
};
